import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
  getAvailableLanguages,
  getConfigs
} from '../../features/app/selectors';
import promptType from '../../types/prompt';
import { toJS } from '../../utils/immutableUtils';

import Stepper from './Stepper';

const useStyles = makeStyles({
  paper: {
    minWidth: '600px'
  },
  titleRoot: {
    padding: 0
  },
  actionsRoot: {
    padding: '16px 24px'
  }
});

const Prompt = ({
  isOpen,
  steps,
  activeStep,
  data,
  promptState,
  setPromptState,
  onCancel,
  onDone,
  onNext
}) => {
  const classes = useStyles();
  // const { formatMessage } = useIntl();
  const languages = toJS(useSelector(getAvailableLanguages), []);
  const langauageLabels = useSelector(getConfigs).toJS().languageDisplayLabels;

  function createLanguageDisplayLabel(data) {
    const result = {};
    data.forEach(i => {
      result[i.languageCode] = i.displayLabel;
    });
    return result;
  }

  const displayLabels =
    langauageLabels && createLanguageDisplayLabel(langauageLabels);

  const languagesWithNames =
    displayLabels &&
    languages.map(language => ({
      code: language,
      name: displayLabels[language]
    }));

  if (!isOpen) {
    return null;
  }

  const { Content } = steps.find(step => step.number === activeStep);
  const lastStepNumber = _.maxBy(steps, 'number').number;
  const isLastStep = activeStep === lastStepNumber;

  return (
    <Dialog open={isOpen} classes={{ paper: classes.paper }}>
      <DialogTitle classes={{ root: classes.titleRoot }}>
        <Stepper activeStep={activeStep} steps={steps} />
      </DialogTitle>
      <DialogContent>
        <Content
          data={data}
          state={promptState}
          setState={setPromptState}
          languages={languagesWithNames}
        />
      </DialogContent>
      <DialogActions classes={{ root: classes.actionsRoot }}>
        <Button color="primary" onClick={onCancel}>
          <FormattedMessage id="prompt.actionCancelLabel" />
        </Button>
        {!isLastStep && (
          <Button color="primary" variant="contained" onClick={onNext}>
            <FormattedMessage id="prompt.actionNextLabel" />
          </Button>
        )}
        {isLastStep && (
          <Button color="primary" variant="contained" onClick={onDone}>
            <FormattedMessage id="prompt.actionDoneLabel" />
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

Prompt.propTypes = promptType;

export default Prompt;
